import _ from 'lodash';
import { vault } from '../../actions/actionTypes';
export const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case vault.FETCH_VAULT_NOTES:
            const fetchVaultNotesPayload = action.payload;
            if (fetchVaultNotesPayload.firstFetch) {
                return { ..._.mapKeys(fetchVaultNotesPayload.notes, 'timestamp') };
            }
            return { ...state, ..._.mapKeys(fetchVaultNotesPayload.notes, 'timestamp') };
        case vault.CREATE_NOTE:
            const createNotePayload = action.payload;
            return { [createNotePayload.timestamp]: createNotePayload, ...state };
        case vault.DELETE_NOTE:
            const deleteNotePayload = action.payload;
            const newState = { ...state };
            delete newState[deleteNotePayload];
            return newState;
        case vault.LOGOUT_NOTES:
            return initialState;
        default:
            return state;
    }
}
